import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { IconButton, MapMarkerIcon, Tooltip } from 'evergreen-ui';
import { stationSelector } from 'Features/App/Dictionaries/dictionariesSlice';
import { selectStationAndCenterZoom } from 'Features/Map/mapSlice';

/** Кнопка, которая делает переход к текущей станции на карту */
export function ShowStationOnMap({ stationId }:{ stationId: number}) {
  const dispatch = useDispatch();
  const station = useSelector(stationSelector(stationId));
  const onClickShowOnMap = () => {
    dispatch(selectStationAndCenterZoom(station));
  };

  return (
    <Tooltip content="Показать станцию на карте">
      <IconButton
        is={Link}
        to="/"
        icon={MapMarkerIcon}
        appearance="minimal"
        onClick={onClickShowOnMap}
        size={'small'}
      />
    </Tooltip>
  );
}
export const MemoShowStationOnMap = React.memo(ShowStationOnMap);
MemoShowStationOnMap.displayName = 'MemoShowStationOnMap';
export default ShowStationOnMap;
